// TopBarV2 (Connect) — bản ĐẤU NỐI của host cho vỏ dùng chung @cnv/ui/layout/TopBarV2.
//
// Vỏ (cnv-ui) lo logo + breadcrumb + ô tìm kiếm ⌘K. File này lo phần RIÊNG của host:
//   - breadcrumb: getBreadcrumbs(menu, path) — cnv-ui nhận (menu, path), Core nhận (path),
//     nên vỏ chung nhận `crumbs` đã tính sẵn thay vì tự gọi.
//   - avatar: dùng LẠI UserMenu của cnv-ui, đưa lên thanh trên CHỈ bằng CSS (ui-v2.css lật
//     neo popup từ bottom-left sang top-right), KHÔNG sửa file dùng chung với Core.
//     Dưới 1024px thanh này bị ẩn nên avatar hiện ở đáy rail — RailBottomV2.jsx lo.
//     Popup đó chứa cả ngôn ngữ lẫn giao diện sáng/tối.
//
// Cụm "gói đang dùng" (PlanBadgeV2) đã có từ 15/08 — bản RIÊNG của Connect, KHÔNG chép
// nguyên của Work: mô hình gói hai bên khác đời (bậc gói là chuỗi thay vì số, và không có
// bảng tên sản phẩm). Lý do đầy đủ ghi trong chính PlanBadgeV2.jsx.
//
// Nút «Help» (11/10/2026; từ 13/10/2026 là cụm DÙNG CHUNG CNV Work — @cnv/ui support-help/HelpMenu):
// chat · góp ý / báo lỗi · yêu cầu của workspace gửi đội hỗ trợ + link trung tâm trợ giúp + thông báo
// yêu cầu có cập nhật (Site Connect không có chuông). Màn hẹp / v1 không có thanh này ⇒ widget giữ
// bong bóng góc phải dưới.
//
// Công tắc v1/v2 KHÔNG ở đây: nó nằm ở đáy menu trái (RailBottomV2).

import { useLocation } from 'react-router-dom';
import { getBreadcrumbs } from '@cnv/ui/navigation/menuUtils';
import TopBarShell from '@cnv/ui/layout/TopBarV2';
import UserMenu from '@cnv/ui/layout/sidebar/UserMenu';
import PlanBadgeV2 from './PlanBadgeV2';
import WorkspaceSwitcherV2 from './WorkspaceSwitcherV2';
import HelpMenu from '@cnv/ui/support-help/HelpMenu';
import SupportBell from '@cnv/ui/support-help/SupportBell';

export default function TopBarV2({ menu = [], brand = {} }) {
  const location = useLocation();
  const crumbs = getBreadcrumbs(menu, location.pathname) || [];

  return (
    // `workspace` là slot của vỏ, đứng ngay sau tên app: workspace là NGỮ CẢNH của cả trang
    // (mọi dữ liệu bên dưới thuộc về nó) nên phải nằm cùng cụm định danh bên trái, trước
    // gạch phân cách và breadcrumb. Core truyền rỗng — bản cài riêng không có gì để đổi.
    <TopBarShell brand={brand} crumbs={crumbs} workspace={<WorkspaceSwitcherV2 />}>
      {/* Gói đang dùng + số chỗ + hạn — đứng TRƯỚC avatar: mắt đọc trái→phải là gói → avatar,
          giống cnvwork-saas. Bấm vào ra Kho ứng dụng. */}
      <PlanBadgeV2 />

      {/* Trợ giúp & góp ý gửi đội hỗ trợ (11/10/2026) — tự ẩn khi cụm chưa cấu hình widget. */}
      <HelpMenu />

      {/* Chuông «Thông báo hỗ trợ» (13/10/2026, sếp Phú: «sao ko thấy chuông thông báo») — yêu cầu của workspace
          vừa được đội hỗ trợ đổi trạng thái / trả lời; bấm mở đúng yêu cầu. Cùng điều kiện hiện với nút Help. */}
      <SupportBell />

      <span className="v2-topbar__user">
        <UserMenu />
      </span>
    </TopBarShell>
  );
}
